<div class="row">
  <div class="col-12">
    <div class="form-container">
      <form (ngSubmit)="form.submit()" [formGroup]="form">

        <h1>Inviter un nouvel employé à joindre votre organisation</h1>

        <app-alert-messages [maximumNumberOfMessages]="1"></app-alert-messages>

        <div class="row mb-3">
          <div class="col-6">
            <!-- First name -->
            <magieno-input-text-field [advancedFormControl]="email"></magieno-input-text-field>
          </div>
          <div class="col-6">
            <!-- First name -->
            <magieno-select [advancedFormControl]="role"></magieno-select>
          </div>
        </div> <!-- / .row -->

        <!-- Button -->
        <magieno-button [button]="form.getButton('SAVE')" class="mb-5"></magieno-button>

      </form>
    </div>
  </div>
</div>